import React from 'react'
import RenewEnergyBreadCrumb from './RenewEnergyBreadCrumb';
import EnergyDashboard from './EnergyDashboard';
function EnergyDashboardPage() {
    return ( 
        <div className = "container-fluid">
            <>
            <RenewEnergyBreadCrumb />
            <EnergyDashboard />
            </>
        </div>
     );
}

export default EnergyDashboardPage;